import {SktErrors} from 'socketmobile-capturejs';
import config from '../config.json';
import JsonRpc from '../helpers/jsonrpc';

const logger = {
  log: (message, arg) => {
    if(arg){
      console.log(message, arg);
    }
    else {
      console.log(message);
    }
  }
};
const rootCaptureUrl = '/Capture/v1/api';
const jsonRpc = new JsonRpc(`${config.companionUrl}${rootCaptureUrl}`, logger);
let jsonRpcId = 1;
const websocketUrl = `${config.companionUrl}${rootCaptureUrl}`.replace(/^http/, 'ws');
const REPLY_WITH_SUCCESS = 1;
const REPLY_WITH_ERROR = 2;
const DO_NOT_REPLY = 3;
const answersToRequest = [
  { name: 'auto reply with success', id: REPLY_WITH_SUCCESS, selected: true },
  { name: 'auto reply with an error', id: REPLY_WITH_ERROR },
  { name: 'do not reply', id: DO_NOT_REPLY }
];
let websocket;
let eventsReceived = [];
let notificationsReceived = [];
let troyEventNotifyCallback;
let continueLongPolling = false;
let longPollingHasEnded = false;
let lastEventId = 0;
let troyDevices = [];
let reverseClients = [];

const getPropertyResponse = event => {
  const method = `${event.method}response`.replace('request','');
  const propertyResponse = {
    jsonrpc: event.jsonrpc,
    id: jsonRpcId++,
    method,
    params:{
      handle: event.params.handle,
      property: {
        id: event.params.property.id,
        type: 0 //None : Here we should return a result that match a property ID (like a friendly name for Get friendlyNameID)
      }
    } 
  };
  return propertyResponse;
}

const sendResponse = async propertyResponse => {
  const response = await jsonRpc.sendRequest(propertyResponse);
  console.log('=>', propertyResponse);
  addPropertyResponseToEvents(propertyResponse);
  return response;
}

const applyAutoResponse = async event => {
  if(event.params){
    const { handle } = event.params;
    let targetDevice = troyDevices.find(d => d.handle === handle);
    console.log('applyAutoResponse: ', targetDevice);
    if(!targetDevice){
      targetDevice = reverseClients.find(d => d.handle === handle);
      console.log('applyAutoResponse from reverseClients: ', targetDevice);
    }
    const answerToRequest = targetDevice?.answerToRequest ?? undefined;
    if(answerToRequest){
      const propertyResponse = getPropertyResponse(event);
      switch(answerToRequest.id){
        case REPLY_WITH_SUCCESS:
          await sendResponse(propertyResponse);
          break;
        case REPLY_WITH_ERROR:
          propertyResponse.params.error = {
            code: SktErrors.ESKT_NOTSUPPORTED, 
            message: 'This property is not supported by the troy device'
          };
          await sendResponse(propertyResponse);
          break;
      }
    }
  }
}

/* event:
  {
    "id":1988147716,
    "jsonrpc":"2.0",
    "method":"troysetpropertyrequest",
    "params":{
      "handle":891759975,
      "appId":"web:capturetestbench.socketmobile.dev",
      "property":{
        "id":1179653,
        "type":2,
        "value":1
      }
    }
  }
*/
const onReceiveTroyEvent = event => {
  let list = notificationsReceived;
  if(event.id){
    list = eventsReceived;
  }
  if(list.length > 100 ){
    list = [];
    list.push({lastEventId, event:{
      jsonrpc: '2.0',
      error: {
        code: SktErrors.ESKT_QUEUERESETED,
        message: 'Error troy event buffer overflow'
      }
    }});
    lastEventId++;
  }
  console.log('add troy request/notification to the queue: ', event);
  list.push({ id:lastEventId, event });
  lastEventId++;

  try {
    if(troyEventNotifyCallback){
      troyEventNotifyCallback(lastEventId);
    }
    if(list === eventsReceived){
      applyAutoResponse(event);
    }
  }
  catch(err){
    console.error(err);
    console.log('remove the troy event notify callback');
    troyEventNotifyCallback = undefined;
  }
}

const startWebSocket = async (handle, receiveEventCallback) =>{
  const promise = new Promise((resolve, reject) => {
    try{
      websocket = new WebSocket(websocketUrl);
    }
    catch(err){
      reject(err);
    }
    websocket.onopen = (ev) => {
      console.log('websocket is open!!!', ev);
      const waitForRequest = {
        jsonrpc: '2.0',
        id: jsonRpcId++,
        method: 'troywaitforrequest',
        params:{
          handle
        }
      };
      console.log('=>', waitForRequest);
      websocket.send(JSON.stringify(waitForRequest));
    };
    websocket.onclose = () => {
      console.log('websocket onclose');
    };
    
    websocket.onmessage = event => {
      try{
        const troyEvent = JSON.parse(event.data);
        if(troyEvent.error) {
          throw(troyEvent.error);
        }
        websocket.onmessage = eventReceived => {
          try{
            console.log('websocket receives: ', eventReceived.data);
            const troyEvent = JSON.parse(eventReceived.data);
            console.log('<=', troyEvent);
            receiveEventCallback(troyEvent);
          }
          catch(err){
            // unable to parse the eventReceived
            console.error(err);
          }
        }
        return resolve(true);
      }
      catch(err) {
        reject(err);
      }
    }
  });
  return promise;
};

const stopWebsocket = () => {
  if(websocket){
    websocket.close();
    websocket = undefined;
  }
}

async function* sendWaitForRequest(handle) {
  for(;;){
    const waitForRequest = {
      jsonrpc: '2.0',
      id: jsonRpcId++,
      method: 'troywaitforrequest',
      params:{
        handle
      }
    };

    let response;
    try{
      response = await jsonRpc.sendRequest(waitForRequest);
    }
    catch(err){
      if(!err.error || err.error.code !== SktErrors.ESKT_WAITTIMEOUT){
        console.error(err);
        throw(err);
      }
      response = err;
    }
    yield response;
  }
}

const startLongPolling = (handle, receiveEventCallback) => {
  setTimeout(async () => {
    const waitForRequestLongPolling = sendWaitForRequest(handle);
    continueLongPolling = true;
    longPollingHasEnded = false;
    for await (var response of waitForRequestLongPolling){
      if(response.result){
        receiveEventCallback(response.result);
      }
      if(continueLongPolling === false){
        break;
      }
    }
    longPollingHasEnded = true;
  }, 1);
};

const stopLongPolling = () => {
  continueLongPolling = false;
  const promise = new Promise(async resolve => {
    while (longPollingHasEnded === false){
      console.log('wait for the long polling to end');
      await new Promise(res => setTimeout(res, 1000));
    }
    console.log('done with long polling?');
    resolve(true);
  });
  return promise;
}

const openReverseClient = async (appId, developerId, appKey, captureHandle, scope, rootProperties, withWebSocket) => {
  const openReverseClientRequest = {
    jsonrpc: '2.0',
    id: jsonRpcId++,
    method: 'troyopenreverseclient',
    params:{
      appId,
      developerId,
      appKey,
      captureHandle: parseInt(captureHandle, 10),
      scope,
      propertyIDs: rootProperties
    }
  };

  const response = await jsonRpc.sendRequest(openReverseClientRequest);
  
  if(typeof response.result !== undefined){
    if(withWebSocket === false){
      console.log('Option set to NOT use websocket');
      startLongPolling(response.result.handle, onReceiveTroyEvent);
    } else {
      startWebSocket(response.result.handle, onReceiveTroyEvent);
    }
    reverseClients.push({ handle: response.result.handle });
    return response.result.handle;
  }
};

const close = async handle => {
  const closeRequest = {
    jsonrpc: '2.0',
    id: jsonRpcId++,
    method: 'troyclose',
    params:{
      handle
    }
  };
  const response = await jsonRpc.sendRequest(closeRequest);
  // only if this is reverse client that we close
  const index = reverseClients.findIndex(h => h.handle === handle);
  if(index !== -1){
    reverseClients.splice(index, 1);
    if(continueLongPolling) {
      await stopLongPolling();
    }
    else {
      stopWebsocket();
    }
  }
  if(typeof response.result !== undefined){
    return response.result;
  }
  throw(response);
};

const openTroyDevice = async (reverseClientHandle, deviceName, deviceGuid, deviceType) => {
  const openTroyDeviceRequest = {
    jsonrpc: '2.0',
    id: jsonRpcId++,
    method: 'troyopendevice',
    params:{
      type: deviceType,
      guid: deviceGuid,
      name: deviceName,
      handle: reverseClientHandle
    }
  };
  const response = await jsonRpc.sendRequest(openTroyDeviceRequest);
  if(typeof response.result !== undefined){
    return response.result.handle;
  }
  throw(response);
};

const sendTroyEvent = async (handle, event) => {
  const sendNotifyEvent = {
    jsonrpc: '2.0',
    id: jsonRpcId++,
    method: 'troynotifyevent',
    params:{
      handle,
      event
    }
  };
  const response = await jsonRpc.sendRequest(sendNotifyEvent);
  if(typeof response.result !== undefined){
    return response.result;
  }
  throw(response);
}

const getTroyEventRequest = () => {
  return [...eventsReceived];
}

const getTroyEventNotifications = () => {
  return [...notificationsReceived];
}

const setTroyEventNotifyCallback = async (callback, lastId) => {
  troyEventNotifyCallback = callback;
  let promise = new Promise(resolve =>{
    if(!lastId || lastId< lastEventId){
      if(troyEventNotifyCallback){
        setTimeout(() => {
          troyEventNotifyCallback(lastEventId-1);
          resolve(lastEventId);
        }, 1);
      }
      else{
        resolve(lastEventId);
      }
    }
    else{
      resolve(lastEventId);
    }
  });
  return promise;
}

const addPropertyResponseToEvents = propertyResponse => {
  eventsReceived.push({lastEventId, event:propertyResponse});
  lastEventId++;
  if(troyEventNotifyCallback){
    troyEventNotifyCallback(lastEventId-1);
  }
}

const sendPropertyResponse = async (get, handle, property) => {
  const propertyResponse = {
    jsonrpc: '2.0',
    id: jsonRpcId++,
    method: get? 'troygetpropertyresponse' : 'troysetpropertyresponse',
    params:{
      handle,
      property
    }
  };
  const response = await sendResponse(propertyResponse);
  if(typeof response.result !== undefined){
    return response.result;
  }
  throw(response);
}

const getAnswersToRequest = () => {
  return answersToRequest
}

// this is mostly for the Auto Answer feature
const updateTroyDevicesList = list => {
  troyDevices = [...list];
}

// this is mostly for the Auto Answer feature
const updateReverseClientsList = list => {
  reverseClients = [...list];
}

export default {
  openReverseClient,
  close,
  openTroyDevice,
  sendTroyEvent,
  getTroyEventRequest,
  setTroyEventNotifyCallback,
  sendPropertyResponse,
  getAnswersToRequest,
  updateTroyDevicesList,
  updateReverseClientsList,
  getTroyEventNotifications
};